import React, { useEffect, useState } from "react";
import Result from "./Result";
import { useParams } from "react-router-dom";

export default function NewResult() {
  const params = useParams<{
    value: string;
    type: string;
  }>();

  const [value, setValue] = useState<number[]>([]);
  const [type, setType] = useState<string>("");

  useEffect(() => {
    if (params.value) {
      setValue(JSON.parse(params.value));
    }
    if (params.type) {
      setType(decodeURI(params.type));
    }
  }, [params.type, params.value]);

  return (
    <div style={{ height: "100vh" }}>
      <img
        src="/doctorApp/bg.png"
        style={{
          position: "absolute",
          zIndex: 1,
          top: 0,
          width: "100vw",
          height: "100vh",
        }}
      />
      <div
        style={{
          width:"100%",
          height:"100%",
          position: "absolute",
          zIndex: 2,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Result value={value} tumourType={type}/>
      </div>
    </div>
  );
}
